// extracted by mini-css-extract-plugin
export default {"button":"profile-button_button__fqP6M"};